export const selectEnvironment = (state) => state.environment;

export const selectFeatureSwitches = (state) =>
    state.environment.featureSwitches;
export const selectIsFeatureEnabled = (featureName) => (state) =>
    selectFeatureSwitches(state)?.[featureName] === true;

export const selectEnvVariables = (state) => state.environment.variables;

export const selectExperiments = (state) => state.environment.experiments;

export const selectSingleExperiment = (experimentName) => (state) =>
    selectExperiments(state)?.find((e) => e.id === experimentName.id) || {};

export const selectWebLiveUrl = (state) =>
    state.environment.variables.PUBLIC_WEB_LIVE_URL;

export const selectBrowserName = (state) => state.environment.browserName;
